export default "__VITE_ASSET__Bra35qMX__"